
export const mapDataForClient = (userIn2n) => ({
  assignedGroups: (userIn2n && userIn2n.assignedGroups && userIn2n.assignedGroups.length > 0)
    ? userIn2n.assignedGroups.map((group) => ({ value: group.id, label: group.name }))
    : null,
  availableGroups: (userIn2n && userIn2n.availableGroups && userIn2n.availableGroups.length > 0)
    ? userIn2n.availableGroups.map((group) => ({ value: group.id, label: group.name }))
    : null,
  rfIdTagOne: userIn2n.AccessCredentials.Cards && userIn2n.AccessCredentials.Cards[0] ? userIn2n.AccessCredentials.Cards[0] : '',
  rfIdTagTwo: userIn2n.AccessCredentials.Cards && userIn2n.AccessCredentials.Cards[1] ? userIn2n.AccessCredentials.Cards[1] : '',
  phoneNumbers: userIn2n?.Calling?.PhoneNumbers?.length > 0 ? userIn2n?.Calling?.PhoneNumbers : [{ Number: '' }],

});
